import { Chip } from '$components'
import * as Popover from '@radix-ui/react-popover'

type PopoverCellProps = {
  values: string[]
  className?: string
}

// TODO: make this show a popover on hover instead - probably use floating ui

export const ChipCell = ({ values, className }: PopoverCellProps) => {
  if (!values || values.length === 0) {
    return '-'
  }

  const visibleChip = (
    <Chip>
      <span className="flex items-center text-xs">
        <div className="max-w-48 overflow-hidden text-ellipsis">
          {values[0]}
        </div>
        {values.length > 1 && (
          <span className="text-gray-500 ml-1 text-nowrap">
            +{values.length - 1} more
          </span>
        )}
      </span>
    </Chip>
  )

  if (values.length === 1) {
    return (
      <div className={className}>
        {visibleChip}
      </div>
    )
  }

  return (
    <Popover.Root>
      <Popover.Trigger
        asChild
        onClick={(e) => e.stopPropagation()}
      >
        <div className={className}>
          {visibleChip}
        </div>
      </Popover.Trigger>

      <Popover.Content
        side="bottom"
        align="start"
        className="fixed rounded-lg z-10 mt-1 !max-w-80 p-2 bg-white border border-gray-100 shadow-sm"
      >
        <div className="flex flex-wrap gap-1 max-w-full">
          {values.map((item, index) => (
            <Chip
              key={index}
              className="break-all"
            >
              {item}
            </Chip>
          ))}
        </div>
      </Popover.Content>
    </Popover.Root>
  )
}
